import { gql } from '@apollo/client'

export const VIRTUAL_COACHING_REQUEST_FIELDS = gql`
  fragment VirtualCoachingRequestFields on VirtualCoachingRequest {
    id
    status
    purchasedAt
    submittedAt
    dueAt
    completedAt
    golfLevel
    struggle
    goal
    offering {
      id
      title
    }
    student {
      id
      firstName
      lastName
      externalId
    }
    videos {
      url
      thumbnailUrl
    }
    response {
      videoUrl
      onformUrl
      thumbnailUrl
      notes
      sharedAt
    }
    studentFeedback {
      reaction
      comment
      createdAt
    }
  }
`

export const GET_VIRTUAL_COACHING_REQUESTS = gql`
  query VirtualCoachingRequests {
    virtualCoachingRequests {
      ...VirtualCoachingRequestFields
    }
  }
  ${VIRTUAL_COACHING_REQUEST_FIELDS}
`

export const GET_VIRTUAL_COACHING_REQUEST = gql`
  query VirtualCoachingRequest($id: ID!) {
    virtualCoachingRequest(id: $id) {
      ...VirtualCoachingRequestFields
      transaction {
        id
      }
    }
  }
  ${VIRTUAL_COACHING_REQUEST_FIELDS}
`

export const GET_VIRTUAL_COACHING_SUMMARY = gql`
  query VirtualCoachingSummary {
    virtualCoachingRequests {
      id
      status
      dueAt
      offering {
        id
        title
      }
      student {
        id
        firstName
        lastName
      }
    }
  }
`

export const SUBMIT_VIRTUAL_COACHING_RESPONSE = gql`
  mutation SubmitVirtualCoachingResponse(
    $input: SubmitVirtualCoachingResponseInput!
  ) {
    submitVirtualCoachingResponse(input: $input) {
      success
      message
      request {
        ...VirtualCoachingRequestFields
      }
    }
  }
  ${VIRTUAL_COACHING_REQUEST_FIELDS}
`
